import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['castle', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1,-9.5h1v0.5h-1zM-1,-9h0.5v2h-0.5zM0,-9h0.5v2h-0.5zM-3.5,-7h1v1h-1zM-1,-7h1.5v0.5h-1.5zM2,-7h1v0.5h-1zM-2,-6.5h2.5v0.5h-2.5zM2,-6.5h1.5v0.5h-1.5zM-3.5,-6h4.5v0.5h-4.5zM2,-6h1v0.5h-1zM-2,-5.5h4v0.5h-4zM-1,-5h2v0.5h-2z',
    },
    {
      paint: [
        ['castle', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M1,-9.5h1v0.5h-1zM-0.5,-9h0.5v0.5h-0.5zM0.5,-9h1.5v3h-1.5zM-0.5,-7.5h0.5v0.5h-0.5zM1,-6h1v0.5h-1zM2.5,-5.5h1v0.5h-1zM1.5,-5h2v0.5h-2zM0.5,-4.5h1.5v0.5h-1.5zM3,-4.5h0.5v1h-0.5zM0.5,-4h0.5v1h-0.5zM-2,-3.5h1v0.5h-1zM2.5,-3.5h1v0.5h-1zM0.5,-3h3v2.5h-3zM-1,-2.5h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM0.5,-0.5h2.5v0.5h-2.5zM-1.5,0h1v0.5h-1zM0.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['castleRoof', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-0.5,-12.5h0.5v1h-0.5zM-1,-11.5h1v1h-1zM-1.5,-10.5h1.5v0.5h-1.5zM-1.5,-10h2v0.5h-2zM0,-9.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['castleRoof', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M0,-12.5h0.5v0.5h-0.5zM0,-12h1v1h-1zM0,-11h1.5v0.5h-1.5zM0,-10.5h2v0.5h-2zM0.5,-10h1.5v0.5h-1.5zM0.5,-9.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'castle',
      d: 'M3,-6h0.5v0.5h-0.5zM-3.5,-5.5h1.5v0.5h-1.5zM2,-5.5h0.5v0.5h-0.5zM-3.5,-5h2.5v0.5h-2.5zM1,-5h0.5v0.5h-0.5zM-3.5,-4.5h4v1h-4zM-3.5,-3.5h1.5v0.5h-1.5zM-1,-3.5h1.5v1h-1.5zM-3.5,-3h1v2.5h-1zM-0.5,-2.5h1v3h-1zM1.5,0h0.5v0.5h-0.5zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'shadow',
      d: 'M-0.5,-8.5h0.5v1h-0.5zM2,-4.5h1v0.5h-1zM1,-4h2v0.5h-2zM1,-3.5h1.5v0.5h-1.5zM-2.5,-3h0.5v1h-0.5zM-1.5,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-2,-3h0.5v0.5h-0.5zM-2,-2.5h1v0.5h-1zM-2.5,-2h2v1.5h-2zM-2,-0.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 255,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
